"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleEventManagerImpl = void 0;
/**
 * This class implements the SingleEventManager interface for a single type of Tableau event
 *
 * @template TEventType The Tableau event type this class specializes
 */
class SingleEventManagerImpl {
    constructor(eventType) {
        this._eventType = eventType;
        this._handlers = [];
    }
    get eventType() {
        return this._eventType;
    }
    addEventListener(handler) {
        this._handlers.push(handler);
        return () => this.removeEventListener(handler);
    }
    removeEventListener(handler) {
        const beforeCount = this._handlers.length;
        this._handlers = this._handlers.filter((h) => h !== handler);
        return beforeCount > this._handlers.length;
    }
    triggerEvent(eventGenerator) {
        for (const handler of this._handlers) {
            try {
                const eventModel = eventGenerator();
                handler(eventModel);
            }
            catch (e) {
                // Since this handler could be outside our control, just catch anything it throws and continue on
                continue;
            }
        }
    }
}
exports.SingleEventManagerImpl = SingleEventManagerImpl;
//# sourceMappingURL=SingleEventManagerImpl.js.map